export type TLoadCardProps = {
  key?: string;
  data: any;
  showDropDown?: boolean;
  isRecent?: boolean;
  isResultsCard?: boolean;
  isFavorite?: boolean;
  isWatchedLoads?: boolean;
  isSearchResults?: boolean;
  isMyLoads?: boolean;
  isExpanded?: boolean;
  showReload?: boolean;
  showRate?: boolean;
  showBottomButton?: boolean;
  hideRightTopPart?: boolean;
  handleReload?: () => void;
  handleRightTopButtonClick?: (id: string) => void;
  handleBottomClick?: (id?: string) => void;
  handleCardClick?: (id?: string) => void;
  size?: ELoadCardSize;
  cardClickEnabled?: boolean;
  additionalCssClass?: string;
  hideSpecialServices?: boolean;
  hideDeadHead?: boolean;
  showRateLeft?: boolean;
  hideRightPart?: boolean;
  showLoadIdLeftMobile?: boolean;
  hideSpecialInfoLeft?: boolean;
  showDateTimeRightSection?: boolean;
  withoutDateTime?: boolean;
  isInsertShipment?: boolean;
  withoutYear?: boolean;
  isRecentlyDelivered?: boolean;
  showAdvancedSearchData?: boolean;
  showNewUpdateFlag?: boolean;
  isGlobalSearch?: boolean;
};

export enum ELoadCardSize {
  'small' = 'small',
  'medium' = 'medium',
  'large' = 'large',
}
